// This interface corresponds to https://bitbucket.org/pecteam/aion-authorization-resources/src/master/AION.AuthorizationResources/ActivityResources.cs
// Note that if a value has the EnumMember attribute attached, use its value instead (as displayed in /backoffice).

export interface IActivities {
  Organizations?: ActivityAction[];
  'Questionnaire Sections'?: ActivityAction[];
  Rankings?: ActivityAction[];
  Releases?: ActivityAction[];
  Employees?: ActivityAction[];
  'Covered Tasks'?: ActivityAction[];
  Locales?: ActivityAction[];
  'Localized Strings'?: ActivityAction[];
  Verifications?: ActivityAction[];
  Verticals?: ActivityAction[];
  'User Organizations'?: ActivityAction[];
  'Customer Support'?: ActivityAction[];
  Users?: ActivityAction[];
  Reports?: ActivityAction[];
  'Audit Questions'?: ActivityAction[];
  Notifications?: ActivityAction[];
  Subscriptions?: ActivityAction[];
  'Training Tracker'?: ActivityAction[];
  Insurances?: ActivityAction[];
  'Assigned Covered Tasks'?: ActivityAction[];
  Projects?: ActivityAction[];
  'Assigned Contractors'?: ActivityAction[];
  Activities?: ActivityAction[];
  Classes?: ActivityAction[];
  'Business Units'?: ActivityAction[];
  Scoring?: ActivityAction[];
  'Assigned Employees'?: ActivityAction[];
  Programs?: ActivityAction[];
  Qualifications?: ActivityAction[];
  'Released Organizations'?: ActivityAction[];
  'Oq Provider Mapping Values'?: ActivityAction[];
  'Smart Sites'?: ActivityAction[];
  'Smart Workers'?: ActivityAction[];
  ELearning?: ActivityAction[];
  Students?: ActivityAction[];
  'Customer Api Gateway'?: ActivityAction[];
  'Smart Reports'?: ActivityAction[];
  Clients?: ActivityAction[];
  'Region Metrics'?: ActivityAction[];
  'Region Metric Values'?: ActivityAction[];
  'ELearning System Admin'?: ActivityAction[];
  'Released Clients'?: ActivityAction[];
  Accreditations?: ActivityAction[];
  CourseCredits?: ActivityAction[];
  'Operational Metrics'?: ActivityAction[];
  'Operational Metric Values'?: ActivityAction[];
  Trainees?: ActivityAction[];
  'Incident Reports'?: ActivityAction[];
  'Incident Types'?: ActivityAction[];
  'Incident Categories'?: ActivityAction[];
  'Training Releases'?: ActivityAction[];
  'Training Released Contractors'?: ActivityAction[];
  'Searchable Trainees'?: ActivityAction[];
  'Employed Trainees Process'?: ActivityAction[];
  'Registration Emails'?: ActivityAction[];
  'Task Groups'?: ActivityAction[];
  Tasks?: ActivityAction[];
  'Task Statuses'?: ActivityAction[];
  'Incident Root Causes'?: ActivityAction[];
  'Metrics Client Configurations'?: ActivityAction[];
  'Veriforce Organization Links'?: ActivityAction[];
  'Training Compliance Training Requirements'?: ActivityAction[];
  'Training Compliance Contractors'?: ActivityAction[];
  'Training Compliance Employees'?: ActivityAction[];
  Threads?: ActivityAction[];
  Messages?: ActivityAction[];
  'Safety Program Evaluations'?: ActivityAction[];
  'Safety Programs'?: ActivityAction[];
  'Training Compliance Job Types'?: ActivityAction[];
  'Training Compliance Work Groups'?: ActivityAction[];
  'Training Compliance Work Group Job Type Employees'?: ActivityAction[];
  'Experian Credit Data'?: ActivityAction[];
  'Region Report Settings'?: ActivityAction[];
  'Region and Operational Metric Data Feed Jobs'?: ActivityAction[];
  'Incident Work Groups'?: ActivityAction[];
  'Incident Regions'?: ActivityAction[];
  'Third Party Credentials'?: ActivityAction[];
  'Employee Drug And Alcohol Data'?: ActivityAction[];
  'Safety Program Answers'?: ActivityAction[];
  'ESignature Templates'?: ActivityAction[];
  'ESignature Envelopes'?: ActivityAction[];
  'Training Courses'?: ActivityAction[];
  'Trainee Course Credits'?: ActivityAction[];
  'Student Emergency Contact List Report'?: ActivityAction[];
  'Organization Assets'?: ActivityAction[];
  'Class Reservations'?: ActivityAction[];
  'Safety Program Requirement Clients'?: ActivityAction[];
  'Safety Program Mandates'?: ActivityAction[];
  'Contractor Reviews'?: ActivityAction[];
  Services?: ActivityAction[];
  'OSHA Violations Matches'?: ActivityAction[];
  'Scoring Engine Recalculation Messages'?: ActivityAction[];
  Forms?: ActivityAction[];
  'SAML SSO'?: ActivityAction[];
  'OSHA Violations'?: ActivityAction[];
  'Score Sets'?: ActivityAction[];
  'Score Items'?: ActivityAction[];
  'Safety Program Exceptions'?: ActivityAction[];
  Roles?: ActivityAction[];
  Regions?: ActivityAction[];
  Industries?: ActivityAction[];
  'Legacy Questionnaire'?: ActivityAction[];
  'Admin Questions'?: ActivityAction[];
  'Clients Questionnaire'?: ActivityAction[];
  'Contractors Questionnaire'?: ActivityAction[];
  'Published Questionnaire'?: ActivityAction[];
  'Questionnaire Admin'?: ActivityAction[];
  'Organization Main Address'?: ActivityAction[];
  Documents?: ActivityAction[];
  ActivityFeed?: ActivityAction[];
  ActivityFeedSMS?: ActivityAction[];
  ProcessAutomation?: ActivityAction[];
  'Contractor profile: Client’s notes'?: ActivityAction[];
  'Text Translations in the System'?: ActivityAction[];
  'Supply Chain'?: ActivityAction[];
  'Supply Chain auto-add contractors'?: ActivityAction[];
}

export enum ActivityResourceName {
  Organizations = 'Organizations',
  QuestionnaireSections = 'Questionnaire Sections',
  Rankings = 'Rankings',
  Releases = 'Releases',
  Employees = 'Employees',
  CoveredTasks = 'Covered Tasks',
  Locales = 'Locales',
  LocalizedStrings = 'Localized Strings',
  Verifications = 'Verifications',
  Verticals = 'Verticals',
  UserOrganizations = 'User Organizations',
  CustomerSupport = 'Customer Support',
  Users = 'Users',
  Reports = 'Reports',
  AuditQuestions = 'Audit Questions',
  Notifications = 'Notifications',
  Subscriptions = 'Subscriptions',
  TrainingTracker = 'Training Tracker',
  Insurances = 'Insurances',
  AssignedCoveredTasks = 'Assigned Covered Tasks',
  Projects = 'Projects',
  AssignedContractors = 'Assigned Contractors',
  Activities = 'Activities',
  Classes = 'Classes',
  BusinessUnits = 'Business Units',
  Scoring = 'Scoring',
  AssignedEmployees = 'Assigned Employees',
  Programs = 'Programs',
  Qualifications = 'Qualifications',
  ReleasedOrganizations = 'Released Organizations',
  OqProviderMappingValues = 'Oq Provider Mapping Values',
  SmartSites = 'Smart Sites',
  SmartWorkers = 'Smart Workers',
  ELearning = 'ELearning',
  Students = 'Students',
  CustomerApiGateway = 'Customer Api Gateway',
  SmartReports = 'Smart Reports',
  Clients = 'Clients',
  RegionMetrics = 'Region Metrics',
  RegionMetricValues = 'Region Metric Values',
  ELearningSystemAdmin = 'ELearning System Admin',
  ReleasedClients = 'Released Clients',
  Accreditations = 'Accreditations',
  CourseCredits = 'Course Credits',
  OperationalMetrics = 'Operational Metrics',
  OperationalMetricValues = 'Operational Metric Values',
  Trainees = 'Trainees',
  IncidentReports = 'Incident Reports',
  IncidentTypes = 'Incident Types',
  IncidentCategories = 'Incident Categories',
  TrainingReleases = 'Training Releases',
  TrainingReleasedContractors = 'Training Release Contractors',
  SearchableTrainees = 'Searchable Trainees',
  EmployedTraineesProcess = 'Employed Trainees Process',
  RegistrationEmails = 'Registration Emails',
  TaskGroups = 'Task Groups',
  Tasks = 'Tasks',
  TaskStatuses = 'Task Statuses',
  IncidentRootCauses = 'Incident Root Causes',
  MetricsClientConfigurations = 'Metrics Client Configurations',
  VeriforceOrganizationLinks = 'Veriforce Organization Links',
  TrainingComplianceTrainingRequirements = 'Training Compliance Training Requirements',
  TrainingComplianceContractors = 'Training Compliance Contractors',
  TrainingComplianceEmployees = 'Training Compliance Employees',
  Threads = 'Threads',
  Messages = 'Messages',
  SafetyProgramEvaluations = 'Safety Program Evaluations',
  SafetyPrograms = 'Safety Programs',
  TrainingComplianceJobTypes = 'Training Compliance Job Types',
  TrainingComplianceWorkGroups = 'Training Compliance Work Groups',
  TrainingComplianceWorkGroupJobTypeEmployees = 'Training Compliance Work Group Job Type Employees',
  Experian = 'Experian Credit Data',
  RegionReportSettings = 'Region Report Settings',
  RegionMetricDataFeedJobs = 'Region and Operational Metric Data Feed Jobs',
  IncidentWorkGroups = 'Incident Work Groups',
  IncidentRegions = 'Incident Regions',
  ThirdPartyCredentials = 'Third Party Credentials',
  EmployeeDrugAndAlcoholData = 'Employee Drug and Alcohol Data',
  SafetyProgramAnswers = 'Safety Program Answers',
  ESignatureTemplates = 'ESignature Templates',
  ESignatureEnvelopes = 'ESignature Envelopes',
  TrainingCourses = 'Training Courses',
  TraineeCourseCredits = 'Trainee Course Credits',
  StudentEmergencyContactListReport = 'Student Emergency Contact List Report',
  OrganizationAssets = 'Organization Assets',
  ClassReservations = 'Class Reservations',
  SafetyProgramRequirementClients = 'Safety Program Requirement Clients',
  SafetyProgramMandates = 'Safety Program Mandates',
  ContractorReviews = 'Contractor Reviews',
  Services = 'Services',
  OshaViolationsMatches = 'OSHA Violations Matches',
  ScoringEngineRecalculationMessages = 'Scoring Engine Recalculation Messages',
  Forms = 'Forms',
  SamlSso = 'SAML SSO',
  OshaViolations = 'OSHA Violations',
  ScoreSets = 'Score Sets',
  ScoreItems = 'Score Items',
  SafetyProgramExceptions = 'Safety Program Exceptions',
  Subcontractors = 'Subcontractors',
  Roles = 'Roles',
  ClientContractors = 'Client Contractors',
  TrainingTrackerPro = 'Training Tracker Pro',
  Regions = 'Regions',
  Industries = 'Industries',
  ScoringContractorData = 'Scoring Contractor Data',
  SafetyProgramsAI = 'Safety Programs AI',
  PreQualificationGroups = 'Pre-Qualification Groups',
  LegacyQuestionnaire = 'Legacy Questionnaire',
  AdminQuestions = 'Admin Questions',
  ClientsQuestionnaire = 'Clients Questionnaire',
  ContractorsQuestionnaire = 'Contractors Questionnaire',
  PublishedQuestionnaire = 'Published Questionnaire',
  QuestionnaireAdmin = 'Questionnaire Admin',
  SubcontractorReports = 'Subcontractor Reports',
  OrganizationMainAddress = 'Organization Main Address',
  SupplyChain = 'Supply Chain',
  SupplyChainAutoAdding = 'Supply Chain auto-add contractors',
  ActivityDocuments = 'Documents',
  ActivityFeed = 'Activity Feed',
  ActivityFeedSMS = 'Activity Feed - SMS',
  CommonAssessmentStandard = 'Common Assessment Standard',
  AdminSignUp = 'Admin Sign Up',
  ServicesAdmin = 'Services Admin',
  ProcessAutomation = 'Process Automation',
  ContractorProfileClientNotes = 'Contractor profile: Client’s notes',
  TextTranslations = 'Text Translations in the System'
}

export enum ActivityAction {
  None = 'None',
  Read = 'Read',
  Write = 'Write',
  Manage = 'Manage',
  Audit = 'Audit'
}
